
import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  NavBar,
  SkeletonLoader,
  ActionableHelperView,
  HelperView,
  Pagination,
  ContextColorProvider,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { Notification } from '@/modules/common/components/Notification';
import { NotesList } from './components/NotesList';
import { ApolloQueryResult } from '@apollo/client';
import {
  GetTradeNotesQuery,
  GetTradeNotesDocument,
  TradeBrokerageNoteYearly,
  TradeBrokerageNote
} from '@/modules/common/services/graphql/server/server.sdk';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import {
  trackDailyNoteDownload,
  trackTradeNotesBackClick,
  trackTradeNotesViewLoad
} from './trackers';
import { getDailyBrokerageNote } from '../../services/notes-statements';

@Component({
  components: {
    NavBar,
    BackButton,
    NotesList,
    SkeletonLoader,
    ActionableHelperView,
    HelperView,
    Pagination,
    ContextColorProvider,
    LoaderIndicator,
    Notification
  }
})
export default class TradeNotesView extends Vue {
  @Prop({ type: Boolean, default: true })
  readonly showNavbar!: boolean;

  private notesByPage = 30;
  notes: TradeBrokerageNoteYearly[] = [];
  isLoading = false;
  isPdfLoading = false;
  isError = false;
  totalPages = 1;
  pageIndex = 1;
  readonly NebraskaColors = NebraskaColors;

  created() {
    this.loadNotes();
    trackTradeNotesViewLoad();
  }

  get hasNotes() {
    return this.notes && this.notes.length !== 0;
  }

  private async loadNotes(page = 1) {
    this.isLoading = true;
    try {
      const { data }: ApolloQueryResult<GetTradeNotesQuery> =
        await this.$apollo.query({
          query: GetTradeNotesDocument,
          variables: {
            size: this.notesByPage,
            index: page
          }
        });

      const tradeAvailable = data!.trade!.status!.enabled;
      const notes = (tradeAvailable
        ? data!.trade!.brokerageNotes!.listYearly
        : []) as unknown as TradeBrokerageNoteYearly[];

      this.notes = notes;
      this.totalPages = data!.trade!.brokerageNotes!.page!.amount!;
    } catch {
      this.isError = true;
    } finally {
      this.isLoading = false;
    }
  }

  onChangePage(page: number) {
    this.pageIndex = page;
    this.loadNotes(this.pageIndex);
  }

  onBackClick() {
    this.$router.back();
    trackTradeNotesBackClick();
  }

  notifyUser() {
    this.$notify({
      group: 'wrn-trade-notes',
      text: `Não foi possível abrir sua nota de negociação`,
      type: NotificationTypes.error
    });
  }

  async requestDailyNote(note: TradeBrokerageNote) {
    this.isPdfLoading = true;
    try {
      trackDailyNoteDownload(note.date!.formatted);
      const { generatedURL: url } = await getDailyBrokerageNote(note.path!);

      window.open(url, '_blank');
    } catch {
      this.notifyUser();
    } finally {
      this.isPdfLoading = false;
    }
  }
}
